import { createAsyncThunk } from '@reduxjs/toolkit';
import { getWarehouseClientsRequest, updateWarehouseClientRequest } from './warehouseClientsApi';
import { selectCurrentWarehouseId } from '../warehouseContext/warehouseContextSlice';
import { extractApiError } from '../../utils/errors';

/**
 * Loads the clients of the warehouse in use, or of every warehouse in reach
 * when none is picked. The endpoint is not paginated: a warehouse has a
 * handful of clients.
 *
 * @returns {Promise<Array<object>>}
 */
export const fetchWarehouseClients = createAsyncThunk(
  'warehouseClients/fetchWarehouseClients',
  async (_, { getState, rejectWithValue }) => {
    try {
      const params = {};
      const warehouseId = selectCurrentWarehouseId(getState());
      if (warehouseId) params.warehouse = warehouseId;

      const { data } = await getWarehouseClientsRequest(params);
      return data.clients || [];
    } catch (error) {
      console.error('Error fetching warehouse clients:', error);
      return rejectWithValue(extractApiError(error, 'No se pudieron obtener los clientes'));
    }
  }
);

/**
 * Switches one preference of one client. The answer is the row as the server
 * left it, and that is what the listing takes: nothing else changed.
 *
 * @param {{contractId: number, key: 'auto_reserve'|'require_picking'|'seller_can_reserve', value: boolean}} params
 * @returns {Promise<object>} The updated row.
 */
export const updateWarehouseClient = createAsyncThunk(
  'warehouseClients/updateWarehouseClient',
  async ({ contractId, key, value }, { rejectWithValue }) => {
    try {
      const { data } = await updateWarehouseClientRequest(contractId, { [key]: value });
      return data;
    } catch (error) {
      console.error('Error updating warehouse client:', error);
      return rejectWithValue(extractApiError(error, 'No se pudo guardar la preferencia'));
    }
  }
);
